export const GetSystemIntegrationId = (data: any[]) => {
    const GOOGLE_ID = '3b00775f-9b50-4a7d-926f-1192e2e3033e';
    const OUTLOOK_ID = '6e0e6a9c-7a37-4bda-8d6a-d7d61f00b828';

    const lowerIds = data
        ?.map(d => d.SystemIntegrationId?.toString().trim().toLowerCase())
        .filter(Boolean) || [];

    const ids: string[] = [];
    if (lowerIds.includes(GOOGLE_ID.toLowerCase())) ids.push(GOOGLE_ID);
    if (lowerIds.includes(OUTLOOK_ID.toLowerCase())) ids.push(OUTLOOK_ID);
    return ids;
};


